export const CoreDataSecurityMonitorsByIdName = 'CoreDataSecurityMonitorsById';
